import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { ColumnConfig } from "@shared/components/Grid/types";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SnButton from "@shared/components/SnButton";
import { showPopupModal } from "@widgets/CommonModal";
import SN_QMS_BAS_REG_002_POP_001 from "@menu/QMS/SN_QMS_BAS_REG_002/SN_QMS_BAS_REG_002_POP_001";
import SN_QMS_BAS_REG_002_POP_002 from "@menu/QMS/SN_QMS_BAS_REG_002/SN_QMS_BAS_REG_002_POP_002";
interface Props {
  Menuprops: menuInfo;
}

const SN_QMS_BAS_REG_002 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const { userInfo } = global();

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      const param = {
        id: "sn_qms_bas_reg_002_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(param);
      setDataSources({
        grid1: data[0],
        grid2: data[1],
      });
    } catch (error: any) {}
  };

  const onInsert = () => {
    try {
      return;
    } catch (error: any) {}
  };

  const onAddRow = () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }
      if (gridRefs.current["grid2"].current?.getDisplayedRowCount() === 0) {
        showDialog("alter", "검사규격할당을 진행 후 추가가 가능합니다.");
        return false;
      }
      let cd_sip: any = null;

      gridRefs.current["grid2"].current.forEachFilteredNode((node: any) => {
        if (node.data && !cd_sip) {
          cd_sip = node.data.cd_sip;
        }
      });

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }
      const searchInfo = searchRef.current.getFormdata();
      const maxNoLine =
        gridRefs.current["grid2"].current.getMaxValue("no_line");
      const newRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: searchInfo?.cd_biz,
        fg_insp: "",
        cd_item: focusedNodeH.data?.cd_item,
        no_line: maxNoLine + 1,
        qt_valid: 0,
        cd_sip: cd_sip,
      }; // 빈 객체
      return gridRefs.current["grid2"].current?.addRow(newRow);
    } catch (error: any) {}
  };

  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) {
      return;
    }

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");

    if (!confirm) {
      return; // 사용자가 아니오를 선택하면 함수 종료
    }

    gridRefs.current["grid2"].current?.deleteAllRows();

    const realDeletedRows =
      gridRefs.current["grid2"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      // 실제로 삭제된 행이 없으면 변경 사항을 적용하고 반환합니다.
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return;
    }

    return await onSave();
  };

  const onDeleteRow = () => {
    if (gridRefs.current["grid2"].current?.getDisplayedRowCount() < 1) {
      return;
    }
    gridRefs.current["grid2"].current?.deleteSelectedRows();
  };

  const onSave = async () => {
    try {
      gridRefs.current["grid2"].current?.stopEditing();
      // H 필수값 체크
      const requiredValuesCheckH =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }

      const headerChanges = gridRefs.current["grid2"].current.getChange();
      const headerInserts = headerChanges.insert ?? [];
      if (headerInserts.length < 0) {
        await showDialog("alter", "저장에 실패했습니다.");
        return;
      }

      if (headerChanges.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      const focusedRowNodeH =
        gridRefs.current["grid2"].current.focusedRowNode();

      // 요청 데이터 구성
      const SaveData = {
        qms_sipitem: headerChanges,
      };
      // 저장 API 호출

      const ok = await fnSave("SN_QMS_BAS_REG_002_SAVE_01", SaveData);
      if (!ok) {
        return;
      }

      // 성공적으로 저장된 후 초기화
      gridRefs.current["grid2"].current.resetUpdate();
    } catch (error: any) {
      gridRefs.current["grid2"].current.resetUpdate(true);
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      // 배열로 만들어서 필터링 함수 호출
      const cd_item = selectedRow.cd_item;
      gridRefs.current["grid2"].current.applyFilters({ cd_item: cd_item });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
    } else {
      return;
    }
  };

  const onCellValueChanged = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    if (colId === "yn_sample") {
      if (rowData.yn_sample === "Y") return;
      rowNode.setDataValue("cd_sample", "");
    }
  };
  const onCellValueChangedL = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;

    const qtValid = Number(rowData.qt_valid);

    const formatValue = (val: any, digit: number) => {
      if (val === null || val === undefined || val === "") return val;

      const num = Number(val);
      if (isNaN(num)) return val;

      return num.toFixed(digit);
    };

    if (colId === "qt_valid") {
      if (qtValid == null || qtValid < 0) return;

      const newLcl = formatValue(rowData.dc_lcl ?? 0, qtValid);
      const newUcl = formatValue(rowData.dc_ucl ?? 0, qtValid);

      rowNode.setDataValue("dc_lcl", newLcl, "noEvent");
      rowNode.setDataValue("dc_ucl", newUcl, "noEvent");
    } else if (colId === "dc_lcl" || colId === "dc_ucl") {
      if (qtValid == null || qtValid < 0) return;

      const value = rowData[colId];
      const formatted = formatValue(value, qtValid);

      rowNode.setDataValue(colId, formatted, "noEvent");
    }
  };

  const normalizeResult = (result: any): any[] => {
    if (!Array.isArray(result)) return [];

    if (Array.isArray(result[0])) {
      return result[0];
    }

    return result;
  };

  const onGrid1BtnsClick = async (id: string) => {
    if (id == "AssignSpec") {
      const gridApi = gridRefs.current["grid2"].current;

      const checkedRows = gridRefs.current["grid1"].current.getCheckedRows();
      if (!checkedRows || checkedRows.length === 0) {
        await showDialog(
          "alert",
          "규격할당 할 리스트가 없습니다.\r\n리스트 체크 후 진행해주세요."
        );
        return;
      }

      const selectedFormData = searchRef.current.getFormdata();

      const component = (
        <SN_QMS_BAS_REG_002_POP_001
          selectedData={{ cd_biz: selectedFormData.cd_biz }}
        />
      );

      const result = await showPopupModal({
        title: "검사규격 할당",
        width: "900px",
        height: "700px",
        children: component,
      });

      if (!result || result === "close") return;

      const Result = normalizeResult(result);

      // =====================================================
      // 🔥 1. 하단 데이터 수집
      // =====================================================
      const checkedItems = new Set(checkedRows.map((row: any) => row.cd_item));

      const existingRows: any[] = [];

      gridApi.forEachNode((node: any) => {
        const data = node.data;

        if (!data) return;

        // 🔥 핵심: 내가 체크한 cd_item만 필터링
        if (checkedItems.has(data.cd_item)) {
          existingRows.push(data);
        }
      });

      // 👉 하단 데이터 없음 → 바로 add
      if (existingRows.length === 0) {
        addRows();
        return;
      }

      // =====================================================
      // 🔥 2. cd_sip 비교
      // =====================================================
      const existingSip = existingRows[0]?.cd_sip;
      const newSip = Result[0]?.cd_sip;

      if (existingSip !== newSip) {
        await showDialog(
          "alert",
          "현재 검사규격코드가 다른 데이터를 선택하셨습니다.\n삭제 후 다시 등록 해주세요."
        );
        return;
      }

      // =====================================================
      // 🔥 3. confirm
      // =====================================================
      const confirm = await showDialog(
        "confirmCancel",
        "기존에 등록된 검사항목이 있습니다.\n삭제하고 재등록하시겠습니까?"
      );

      if (confirm === false) return;

      let actionType: "Y" | "C";

      if (confirm === true) actionType = "Y";
      else actionType = "C";

      // =====================================================
      // 🔥 4. Y → 전체 삭제
      // =====================================================
      if (actionType === "Y") {
        const gridApi = gridRefs.current["grid2"].current;

        const checkedItems = new Set(
          checkedRows.map((row: any) => row.cd_item)
        );

        gridApi.forEachNode((node: any) => {
          if (node.isSelected && node.isSelected()) {
            node.setSelected(false);
          }
        });
        // 🔥 2. cd_item 기준으로 강제 선택
        gridApi.forEachNode((node: any) => {
          if (node.data && checkedItems.has(node.data.cd_item)) {
            node.setSelected(true);
          }
        });
        // 🔥 3. 선택된 것 삭제
        gridApi.deleteSelectedRows();

        // 🔥 4. 다시 추가
        addRows();

        return;
      }

      // =====================================================
      // 🔥 5. C → cd_clause 기준 추가
      // =====================================================
      const existingClauseSet = new Set<string>();

      existingRows.forEach((row) => {
        existingClauseSet.add(row.cd_clause);
      });

      addRows(existingClauseSet);

      // =====================================================
      // 🔥 addRow 함수
      // =====================================================
      function addRows(clauseSet?: Set<string>) {
        // 🔥 cd_item별 max no_line 계산
        const itemMaxMap = new Map<string, number>();

        gridApi.forEachNode((node: any) => {
          const item = node.data?.cd_item;
          const line = Number(node.data?.no_line || 0);

          if (!item) return;

          const prev = itemMaxMap.get(item) ?? 0;
          itemMaxMap.set(item, Math.max(prev, line));
        });

        for (const headerRow of checkedRows) {
          const cdItem = headerRow.cd_item;

          let currentMax = itemMaxMap.get(cdItem) ?? 0;

          for (const row of Result) {
            // 🔥 C일 때만 필터
            if (clauseSet) {
              if (clauseSet.has(row.cd_clause)) continue;
            }

            currentMax++;
            const newRow = {
              cd_firm: userInfo.cd_firm,
              cd_biz: selectedFormData.cd_biz,
              fg_insp: row.fg_insp,
              cd_item: cdItem,
              no_line: currentMax,
              cd_clause: row.cd_clause,
              cd_sip: row.cd_sip,
              nm_clause: row.nm_clause,
              dc_lcl: row.dc_lcl,
              dc_ucl: row.dc_ucl,
              yn_sample: row.yn_sample,
              cd_sample: row.cd_sample,
              yn_insp: row.yn_insp,
              dc_unit_cl: row.dc_unit_cl,
              dc_sample: row.dc_sample,
              txt_explain: row.txt_explain,
              dc_rmk: row.dc_rmk,
              qt_valid: 0,
            };
            const addedNode = gridApi.addRow(newRow);
          }
          itemMaxMap.set(cdItem, currentMax);
        }
      }
    }
    if (id == "SpecCode") {
      const checkedRows = gridRefs.current["grid1"].current.getCheckedRows();
      const selectedFormData = searchRef.current.getFormdata();
      const selectedData: any[] = [];
      selectedData.push({
        cd_biz: selectedFormData.cd_biz,
      });
      const component = (
        <SN_QMS_BAS_REG_002_POP_002 selectedDataList={selectedData} />
      );
      const result = await showPopupModal({
        title: "규격코드등록",
        width: "1350px",
        height: "700px",
        children: component,
      });
      if (!result || result === "close") return;

      const Result = result[0];
      for (const key in checkedRows) {
        const addedNode = onAddRow();
        for (const key in Result) {
          addedNode.setDataValue(key, Result[key]);
        }
      }
    }
  };

  const onGrid2BtnsClick = async (id: string) => {
    if (id == "addRow") {
      onAddRow();
    }
    if (id == "deleteRow") {
      onDeleteRow();
    }
  };

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
          onCellValueChanged: onCellValueChanged,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onBtnAddClick: onGrid2BtnsClick,
          onBtnDeleteClick: onGrid2BtnsClick,
          onCellValueChanged: onCellValueChangedL,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              rowSelection: "single",
              title: "품목정보",
              ischeckboxSelection: true,
            }}
            events={grids.grid1.events}
            header={
              <div>
                <SnButton
                  text={"검사규격할당"}
                  onClick={() => {
                    onGrid1BtnsClick("AssignSpec");
                  }}
                />
                <SnButton
                  text={"규격코드등록"}
                  onClick={() => {
                    onGrid1BtnsClick("SpecCode");
                  }}
                />
              </div>
            }
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]} // Grid Name
            columnConfig={grids.grid2.columns} // 컬럼 설정 전달
            rowData={grids.grid2.dataSource} // Datasource
            etcProps={{ rowSelection: "multiple", title: "검사항목정보" }}
            events={grids.grid2.events}
          />
        </SnResizeBar>
      </div>
    </div>
  );
});

export default SN_QMS_BAS_REG_002;
